import React from 'react';
import { deckPages } from '../../data/deck';
interface DeckNavProps {
  active: string;
}

/** Quiet page rail for moving through the presentation. */
export function DeckNav({
  active
}: DeckNavProps) {
  const activeIndex = Math.max(0, deckPages.findIndex(page => page.id === active));
  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <nav aria-label="Presentation pages" className="no-print fixed right-5 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-end gap-3 lg:flex" data-id="element-33" data-mp="1y9jqo802eds7">
      {deckPages.map((page, i) => {
      const isActive = i === activeIndex;
      return <button key={page.id} type="button" onClick={() => goTo(page.id)} aria-label={`Page ${i + 1}: ${page.label}`} aria-current={isActive ? 'true' : undefined} className="group flex items-center gap-3 focus:outline-none" data-id="element-34" data-mp="1je3qdl8w5lnd" data-mpi={i}>
            <span className="pointer-events-none whitespace-nowrap rounded-full bg-paper px-3 py-1 text-[10px] uppercase tracking-[0.16em] text-navy opacity-0 shadow-sm ring-1 ring-navy/[0.08] transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-35" data-mp="20tq0714fts08">
              {String(i + 1).padStart(2, '0')} · {page.label}
            </span>
            <span className={['block w-1.5 rounded-full transition-[height,background-color] duration-200 ease-out group-focus-visible:ring-2 group-focus-visible:ring-blue', isActive ? 'h-6 bg-navy' : 'h-1.5 bg-navy/20 group-hover:bg-navy/50'].join(' ')} data-id="element-36" data-mp="1vwprsjk48d5y" />
          </button>;
    })}
      <span className="mt-2 text-[10px] tabular-nums tracking-[0.12em] text-navy/40" data-id="element-37" data-mp="1d4wzkrcvevza">
        {String(activeIndex + 1).padStart(2, '0')}/{String(deckPages.length).padStart(2, '0')}
      </span>
    </nav>;
}